const matchConfig = {
  pages: {
      login: 'login',
      register: 'register',
      forgotPass: 'forgotPass',
  aichat: 'aichat',
      story: 'story',
      profile: 'profile',
      chat: 'chat'
  },
  // Source toggle for Stories tab: 'human' | 'ai' update 19/12
  // rankTopMatches: Number of top ML-ranked matches to show before randomizing the rest
  // 0 = all random (original behavior), 5 = top 5 ranked + rest random, 35 = all ranked (no randomization)
  stories: {
    source: 'ai',
    rankTopMatches: 5
  },
  form: {
    livingSituationja:[
      {
        value: '0',
        display: '同居者を教えてください'         
      },
      {
        value: '一人暮らし',
        display: '一人暮らし'         
      },
      {
        value: '学生寮',
        display: '学生寮'         
      },
      {
        value: '実家',
        display: '実家'         
      },
      {
        value: 'シェアハウス',
        display: 'シェアハウス'         
      },
      {
        value: 'その他',
        display: 'その他'         
      }
    ],
    studyFieldja:[
      {
        value: '0',
        display: '所属学部'         
      },
      {
        value: '情報',
        display: '情報'         
      },
      {
        value: '機械工',
        display: '機械工'         
      },
{
        value: '経済',
        display: '経済'         
      },
{
        value: '経営',
        display: '経営'         
      },
{
        value: '法',
        display: '法'         
      },
{
        value: '商',
        display: '商'         
      },
{
        value: '現代社会',
        display: '現代社会'         
      },
{
        value: '国際関係',
        display: '国際関係'         
      },
{
        value: '外国語',
        display: '外国語'         
      },
{
        value: '文化',
        display: '文化'         
      },
{
        value: '理',
        display: '理'         
      },
      {
        value: '農',
        display: '農'         
      },
      {
        value: '生命科学',
        display: '生命科学'         
      },
      {
        value: 'その他',
        display: 'その他'         
      }
    ],
    problemCategoryja:[
      {
        value: '0',
        display: 'どんな問題にあっていますか？'         
      },
      {
        value: '時間の使い方',
        display: '時間の使い方'         
      },
      {
        value: '趣味がない',
        display: '趣味がない'         
      },
      {
        value: 'お金',
        display: 'お金'         
      },
{
        value: '勉強',
        display: '勉強'         
      },
{
        value: '就活',
        display: '就活'         
      },
{
        value: '研究',
        display: '研究'         
      },
{
        value: 'コロナ',
        display: 'コロナ'         
      },
{
        value: '人間関係',
        display: '人間関係'         
      },
      {
        value: '健康',
        display: '健康'         
      },
      {
        value: '将来',
        display: '将来'         
      },
      {
        value: 'ペット',
        display: 'ペット'         
      },
      {
        value: '学会発表',
        display: '学会発表'         
      },
      {
        value: '自信がない',
        display: '自信がない'         
      },
      {
        value: 'その他',
        display: 'その他'         
      }
    ],
    relationshipArrja: [
      {
          value: '0',
          display: '失った人は私の...'
      },
      {
          value: '配偶者',
          display: '配偶者'
      },
      {
          value: '祖父母',
          display: '祖父母'
      },
      {
          value: '親',
          display: '親'
      },
      {
          value: '子孫',
          display: '子孫'
      },
      {
          value: '兄弟',
          display: '兄弟'
      },
      {
          value: '孫',
          display: '孫'
      },
      {
          value: '叔母',
          display: '叔母'
      },
      {
          value: '叔父',
          display: '叔父'
      },
      {
          value: '姪',
          display: '姪'
      },
      {
          value: '甥',
          display: '甥'
      },
      {
        value: '友達',
        display: '友達'
      },
      {
          value: 'その他',
          display: 'その他'
      },
      {
        value: 'ほかの人をサポートしたい',
        display: 'ほかの人をサポートしたい'
    }
  ],
    copingStrategyja:[
      {
        value: '0',
        display: 'あなたのストレス解消法を教えてください'         
      },
      {
        value: 'ゲーム',
        display: 'ゲーム'         
      },
      {
        value: 'サイクリング',
        display: 'サイクリング'         
      },
      {
        value: '動画鑑賞',
        display: '動画鑑賞'         
      },
{
        value: 'アニメ',
        display: 'アニメ'         
      },
{
        value: 'ルービックキューブ',
        display: 'ルービックキューブ'         
      },
{
        value: '睡眠',
        display: '睡眠'         
      },
{
        value: '音楽鑑賞',
        display: '音楽鑑賞'         
      },
{
        value: '麻雀',
        display: '麻雀'         
      },
{
        value: '絵を描く',
        display: '絵を描く'         
      },
{
        value: '小説',
        display: '小説'         
      },
{
        value: '漫画',
        display: '漫画'         
      },
      {
        value: '旅行',
        display: '旅行'         
      },
      {
        value: '釣り',
        display: '釣り'         
      },
{
        value: '野球',
        display: '野球'         
      },
{
        value: 'バスケ',
        display: 'バスケ'         
      },
      {
        value: '水泳',
        display: '水泳'         
      },
      {
        value: 'ショッピング',
        display: 'ショッピング'         
      },
{
        value: 'ギター',
        display: 'ギター'         
      },
{
        value: 'グルメ',
        display: 'グルメ'         
      },
      {
        value: 'ゴルフ',
        display: 'ゴルフ'         
      },
      {
        value: 'その他',
        display: 'その他'         
      },
    ],
  relationshipArren: [
          {
              value: '0',
              display: 'The deceased is my...'
          },
          {
            value: 'Partner',
            display: 'Partner'
          },
          {
              value: 'Grandparent',
              display: 'Grandparent'
          },
          {
              value: 'Parent',
              display: 'Parent'
          },
          {
              value: 'Offspring',
              display: 'Offspring'
          },
          {
              value: 'Sibling',
              display: 'Sibling'
          },
          {
              value: 'Grand child',
              display: 'Grand child'
          },
          {
              value: 'Aunt',
              display: 'Aunt'
          },
          {
              value: 'Uncle',
              display: 'Uncle'
          },
          {
              value: 'Niece',
              display: 'Niece'
          },
          {
              value: 'Nephew',
              display: 'Nephew'
          },
          {
            value: 'Friend',
            display: 'Friend'
          },
          {
              value: 'Other',
              display: 'Other'
          },
          {
            value: 'I want to support others',
            display: 'I want to support others'
        }
      ],
      genderArren: [
          {
              value: '0',
              display: 'Your sex/gender'
          },
          {
              value: 'Female',
              display: 'Female'
          },
          {
              value: 'Male',
              display: 'Male'
          },
          {
              value: 'Prefer not to disclose',
              display: 'Prefer not to disclose'
          }
      ],
      livingSituationen: [
        {
          value: '0',
          display: 'Select living situation'
        },
        {
          value: 'Living alone',
          display: 'Living alone'
        },
        {
          value: 'Student dormitory',
          display: 'Student dormitory'
        },
        {
          value: 'Living with parents',
          display: 'Living with parents'
        },
        {
          value: 'Share house',
          display: 'Share house'
        },
        {
          value: 'Other',
          display: 'Other'
        }
      ],
      studyFielden: [
        {
          value: '0',
          display: 'Select study field'
        },
        {
          value: 'Information Technology',
          display: 'Information Technology'
        },
        {
          value: 'Mechanical Engineering',
          display: 'Mechanical Engineering'
        },
        {
          value: 'Economics',
          display: 'Economics'
        },
        {
          value: 'Management',
          display: 'Management'
        },
        {
          value: 'Law',
          display: 'Law'
        },
        {
          value: 'Commerce',
          display: 'Commerce'
        },
        {
          value: 'Contemporary Society',
          display: 'Contemporary Society'
        },
        {
          value: 'International Relations',
          display: 'International Relations'
        },
        {
          value: 'Foreign Languages',
          display: 'Foreign Languages'
        },
        {
          value: 'Culture',
          display: 'Culture'
        },
        {
          value: 'Science',
          display: 'Science'
        },
        {
          value: 'Agriculture',
          display: 'Agriculture'
        },
        {
          value: 'Life Sciences',
          display: 'Life Sciences'
        },
        {
          value: 'Other',
          display: 'Other'
        }
      ],
      problemCategoryen: [
        {
          value: '0',
          display: 'What problem are you facing?'
        },
        {
          value: 'Time management',
          display: 'Time management'
        },
        {
          value: 'No hobbies',
          display: 'No hobbies'
        },
        {
          value: 'Money',
          display: 'Money'
        },
        {
          value: 'Studies',
          display: 'Studies'
        },
        {
          value: 'Job hunting',
          display: 'Job hunting'
        },
        {
          value: 'Research',
          display: 'Research'
        },
        {
          value: 'Pandemic stress',
          display: 'Pandemic stress'
        },
        {
          value: 'Relationships',
          display: 'Relationships'
        },
        {
          value: 'Health',
          display: 'Health'
        },
        {
          value: 'Future',
          display: 'Future'
        },
        {
          value: 'Pets',
          display: 'Pets'
        },
        {
          value: 'Academic presentation',
          display: 'Academic presentation'
        },
        {
          value: 'Lack of confidence',
          display: 'Lack of confidence'
        },
        {
          value: 'Other',
          display: 'Other'
        }
      ],
      copingStrategyen: [
        {
          value: '0',
          display: 'What is your stress relief method?'
        },
        {
          value: 'Gaming',
          display: 'Gaming'
        },
        {
          value: 'Cycling',
          display: 'Cycling'
        },
        {
          value: 'Watching videos',
          display: 'Watching videos'
        },
        {
          value: 'Anime',
          display: 'Anime'
        },
        {
          value: 'Rubik\'s cube',
          display: 'Rubik\'s cube'
        },
        {
          value: 'Sleep',
          display: 'Sleep'
        },
        {
          value: 'Listening to music',
          display: 'Listening to music'
        },
        {
          value: 'Mahjong',
          display: 'Mahjong'
        },
        {
          value: 'Drawing',
          display: 'Drawing'
        },
        {
          value: 'Reading novels',
          display: 'Reading novels'
        },
        {
          value: 'Reading manga',
          display: 'Reading manga'
        },
        {
          value: 'Traveling',
          display: 'Traveling'
        },
        {
          value: 'Fishing',
          display: 'Fishing'
        },
        {
          value: 'Baseball',
          display: 'Baseball'
        },
        {
          value: 'Basketball',
          display: 'Basketball'
        },
        {
          value: 'Swimming',
          display: 'Swimming'
        },
        {
          value: 'Shopping',
          display: 'Shopping'
        },
        {
          value: 'Guitar',
          display: 'Guitar'
        },
        {
          value: 'Other',
          display: 'Other'
        }
      ],
      genderArrja: [
        {
            value: '0',
            display: 'あなたの性別'
        },
        {
            value: '女',
            display: '女'
        },
        {
            value: '男',
            display: '男'
        },
        {
            value: '公開したくない',
            display: '公開したくない'
        }
    ],
    statesja: [
      {
        key: "0",
        value: "0",
        display: "現在住んでいる都道府県"
      },
      {
        key: "HO",
        value: "北海道",
        display: "北海道"
      },
      {
        key: "AO",
        value: "青森県",
        display: "青森県"
      },
      {
        key: "IW",
        value: "岩手県",
        display: "岩手県"
      },
      {
        key: "MI",
        value: "宮城県",
        display: "宮城県"
      },
      {
        key: "AK",
        value: "秋田県",
        display: "秋田県"
      },
      {
        key: "YK",
        value: "山形県",
        display: "山形県"
      },
      {
        key: "FS",
        value: "福島県",
        display: "福島県"
      },
      {
        key: "IB",
        value: "茨城県",
        display: "茨城県"
      },
      {
        key: "AZ",
        value: "栃木県",
        display: "栃木県"
      },
      {
        key: "GU",
        value: "群馬県",
        display: "群馬県"
      },
      {
        key: "SA",
        value: "埼玉県",
        display: "埼玉県"
      },
      {
        key: "CH",
        value: "千葉県",
        display: "千葉県"
      },
      {
        key: "TOK",
        value: "東京都",
        display: "東京都"
      },
      {
        key: "KAG",
        value: "神奈川県",
        display: "神奈川県"
      },
      {
        key: "NI",
        value: "新潟県",
        display: "新潟県"
      },
      {
        key: "FY",
        value: "富山県",
        display: "富山県"
      },
      {
        key: "IS",
        value: "石川県",
        display: "石川県"
      },
      {
        key: "FUI",
        value: "福井県",
        display: "福井県"
      },   
      {
        key: "YS",
        value: "山梨県",
        display: "山梨県"
      },   
      {
        key: "NAG",
        value: "長野県",
        display: "長野県"
      },  
      {
        key: "GI",
        value: "岐阜県",
        display: "岐阜県"
      }, 
      {
        key: "SZ",
        value: "静岡県",
        display: "静岡県"
      },   
      {
        key: "AI",
        value: "愛知県",
        display: "愛知県"
      },    
      {
        key: "SJ",
        value: "三重県",
        display: "三重県"
      },      
      {
        key: "SHI",
        value: "滋賀県",
        display: "滋賀県"
      },   
      {
        key: "KY",
        value: "京都府",
        display: "京都府"
      },  
      {
        key: "OS",
        value: "大阪府",
        display: "大阪府"
      },    
      {
        key: "HY",
        value: "兵庫県",
        display: "兵庫県"
      },   
      {
        key: "NA",
        value: "奈良県",
        display: "奈良県"
      },  
      {
        key: "WA",
        value: "和歌山県",
        display: "和歌山県"
      },  
      {
        key: "TOT",
        value: "鳥取県",
        display: "鳥取県"
      }, 
      {
        key: "SHN",
        value: "島根県",
        display: "島根県"
      },  
      {
        key: "OYA",
        value: "岡山県",
        display: "岡山県"
      },    
      {
        key: "HI",
        value: "広島県",
        display: "広島県"
      }, 
      {
        key: "YAM",
        value: "山口県",
        display: "山口県"
      },  
      {
        key: "CHS",
        value: "徳島県",
        display: "徳島県"
      },  
      {
        key: "KAG",
        value: "香川県",
        display: "香川県"
      },  
      {
        key: "EHI",
        value: "愛媛県",
        display: "愛媛県"
      },  
      {
        key: "KOC",
        value: "高知県",
        display: "高知県"
      },        
      {
        key: "FUO",
        value: "福岡県",
        display: "福岡県"
      },        
      {
        key: "SAG",
        value: "佐賀県",
        display: "佐賀県"
      },  
      {
        key: "NAG",
        value: "長崎県",
        display: "長崎県"
      },
      {
        key: "GUN",
        value: "熊本県",
        display: "熊本県"
      },
      {
        key: "OOB",
        value: "大分県",
        display: "大分県"
      },  
      {
        key: "MIY",
        value: "宮崎県",
        display: "宮崎県"
      },  
      {
        key: "KAS",
        value: "鹿児島県",
        display: "鹿児島県"
      },      
      {
        key: "OKI",
        value: "沖縄県",
        display: "沖縄県"
      },                              
    ],
      statesen: [
          {
            key: "0",
            value: "0",
            display: "Where do you live in Japan"
          },
          {
            key: "Hokkaido",
            value: "Hokkaido",
            display: "Hokkaido"
          },
          {
            key: "Aomori",
            value: "Aomori",
            display: "Aomori"
          },
          {
            key: "Iwate",
            value: "Iwate",
            display: "Iwate"
          },
          {
            key: "Miyagi",
            value: "Miyagi",
            display: "Miyagi"
          },
          {
            key: "Akita",
            value: "Akita",
            display: "Akita"
          },
          {
            key: "Yamagata",
            value: "Yamagata",
            display: "Yamagata"
          },
          {
            key: "Fukushima",
            value: "Fukushima",
            display: "Fukushima"
          },
          {
            key: "Ibaraki",
            value: "Ibaraki",
            display: "Ibaraki"
          },
          {
            key: "Tochigi",
            value: "Tochigi",
            display: "Tochigi"
          },
          {
            key: "Gunma",
            value: "Gunma",
            display: "Gunma"
          },
          {
            key: "Saitama",
            value: "Saitama",
            display: "Saitama"
          },
          {
            key: "Chiba",
            value: "Chiba",
            display: "Chiba"
          },
          {
            key: "Tokyo",
            value: "Tokyo",
            display: "Tokyo"
          },
          {
            key: "Kanagawa",
            value: "Kanagawa",
            display: "Kanagawa"
          },
          {
            key: "Niigata",
            value: "Niigata",
            display: "Niigata"
          },
          {
            key: "Toyama",
            value: "Toyama",
            display: "Toyama"
          },
          {
            key: "Ishikawa",
            value: "Ishikawa",
            display: "Ishikawa"
          },
          {
            key: "Fukui",
            value: "Fukui",
            display: "Fukui"
          },
          {
            key: "Yamanashi",
            value: "Yamanashi",
            display: "Yamanashi"
          },
          {
            key: "Nagano",
            value: "Nagano",
            display: "Nagano"
          },
          {
            key: "Gifu",
            value: "Gifu",
            display: "Gifu"
          },
          {
            key: "Shizuoka",
            value: "Shizuoka",
            display: "Shizuoka"
          },
          {
            key: "Aichi",
            value: "Aichi",
            display: "Aichi"
          },
          {
            key: "Mie",
            value: "Mie",
            display: "Mie"
          },
          {
            key: "Shiga",
            value: "Shiga",
            display: "Shiga"
          },
          {
            key: "Kyoto",
            value: "Kyoto",
            display: "Kyoto"
          },
          {
            key: "Osaka",
            value: "Osaka",
            display: "Osaka"
          },
          {
            key: "Hyogo",
            value: "Hyogo",
            display: "Hyogo"
          },
          {
            key: "Nara",
            value: "Nara",
            display: "Nara"
          },
          {
            key: "Wakayama",
            value: "Wakayama",
            display: "Wakayama"
          },
          {
            key: "Tottori",
            value: "Tottori",
            display: "Tottori"
          },
          {
            key: "Shimane",
            value: "Shimane",
            display: "Shimane"
          },
          {
            key: "Okayama",
            value: "Okayama",
            display: "Okayama"
          },
          {
            key: "Hiroshima",
            value: "Hiroshima",
            display: "Hiroshima"
          },
          {
            key: "Yamaguchi",
            value: "Yamaguchi",
            display: "Yamaguchi"
          },
          {
            key: "Tokushima",
            value: "Tokushima",
            display: "Tokushima"
          },
          {
            key: "Kagawa",
            value: "Kagawa",
            display: "Kagawa"
          },
          {
            key: "Ehime",
            value: "Ehime",
            display: "Ehime"
          },
          {
            key: "Kochi",
            value: "Kochi",
            display: "Kochi"
          },
          {
            key: "Fukuoka",
            value: "Fukuoka",
            display: "Fukuoka"
          },
          {
            key: "Saga",
            value: "Saga",
            display: "Saga"
          },
          {
            key: "Nagasaki",
            value: "Nagasaki",
            display: "Nagasaki"
          },
          {
            key: "Kumamoto",
            value: "Kumamoto",
            display: "Kumamoto"
          },
          {
            key: "Oita",
            value: "Oita",
            display: "Oita"
          },
          {
            key: "Miyazaki",
            value: "Miyazaki",
            display: "Miyazaki"
          },
          {
            key: "Kagoshima",
            value: "Kagoshima",
            display: "Kagoshima"
          },
          {
            key: "Okinawa",
            value: "Okinawa",
            display: "Okinawa"
          }
        ]
  }
}

export default matchConfig
